import React, { useState } from "react";
import SearchBar from "./components/SearchBar";
import Filter from "./components/Filter";
import HotelCardLong from "./components/HotelCardLong";
import NftCard from "../../components/card/NftCard";
import NFt3 from "assets/img/nfts/Nft3.png";
import HotelGrid from "./components/HotelGrid";

const dummyHotel = {
  name: "JW Marriott Hotel New Delhi Aerocity",
  location: "New Delhi, Delhi",
  rating: 5,
  views: 399,
  price: 999,
  originalPrice: 2499,
  mainImage:
    "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  thumbnails: [
    "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
    "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
    "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
    "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
    "https://cf.bstatic.com/static/img/theme-index/bg_luxury/869918c9da63b2c5685fce05965700da5b0e6617.jpg",
  ],
};

const hotels = new Array(12).fill({
  title: "Hotel Title",
  assigned_to: "Unknown User",
  status: "Status",
  image: NFt3,
  created_at: "Date Not Available",
});

export default function HotelList() {
  const [visibleCount, setVisibleCount] = useState(() => {
    if (window.innerWidth < 768) return 3; // sm and below
    if (window.innerWidth > 1600) return 8; // md and above (2 rows if 3 per row)
    return 6; // md and above (2 rows if 3 per row)
  });
  return (
    <div className="mt-10 bg-[#f4f4f4] px-4 py-6 md:px-8">
      <div className="mt-6 flex flex-col gap-5 md:flex-row">
        <Filter extra={"mt-8"} />
        <div className="flex w-full flex-col gap-5 md:w-3/4">
          <SearchBar />
          <HotelCardLong hotel={dummyHotel} />
          <HotelCardLong hotel={dummyHotel} />
          <p className="text-2xl font-medium text-black">Related Hotels</p>
          <div className="flex gap-5 overflow-x-auto pb-3">
            {hotels.slice(0, visibleCount).map((ticket, idx) => (
              <div key={idx} className="min-w-[280px] shrink-0">
                <NftCard
                  title={ticket.title}
                  assigned_to={ticket.assigned_to}
                  status={ticket.status}
                  image={ticket.image}
                  created_at={ticket.created_at}
                />
              </div>
            ))}
          </div>
          <p className="text-2xl font-medium text-black">
            Special Offers For You
          </p>
          <HotelGrid />
        </div>
      </div>
    </div>
  );
}
